import Service from "../../Service";
import Axios from "../../Config/API";
import { IListarEquipesVendas } from "../../../Interfaces/Vendas/EquipeVendas/EquipeVendasInterfaces";

export async function ListarEquipesDeVendasService() {
    return Service(
        Axios.get<Array<IListarEquipesVendas>>(
            `/vendas/equipevendas/listarequipesvendas`
        )
    );
}
export async function GetEquipesDeVendasService(idEquipeVendas: number) {
    return Service(
        Axios.get<IListarEquipesVendas>(
            `/vendas/equipevendas/getequipevendas?idEquipeVendas=${idEquipeVendas}`
        )
    );
}

export async function InsereEquipeVendasService(
    requestBody: IListarEquipesVendas
) {
    return Service(
        Axios.post<Array<IListarEquipesVendas>>(
            `/vendas/equipevendas/insereequipevendas`,
            requestBody
        )
    );
}
export async function AtualizaEquipeVendasService(
    requestBody: IListarEquipesVendas
) {
    return Service(
        Axios.put<Array<IListarEquipesVendas>>(
            `/vendas/equipevendas/atualizaequipevendas`,
            requestBody
        )
    );
}
export async function DeletaEquipeVendasService(idEquipeVendas: number) {
    return Service(
        Axios.delete<Array<IListarEquipesVendas>>(
            `/vendas/equipevendas/deletaequipevendas?idEquipeVendas=${idEquipeVendas}`
        )
    );
}
export async function ExportarEquipeVendasService() {
    return Service(
        Axios.post<Blob>(
            `/vendas/equipevendas/exportarequipevendas`,
            {},
            {
                responseType: "blob",
            }
        )
    );
}
